import React from 'react';
import { MenuIcon, BellIcon, UserIcon } from 'lucide-react';
interface HeaderProps {
  sidebarOpen: boolean;
  setSidebarOpen: (open: boolean) => void;
}
export function Header({
  sidebarOpen,
  setSidebarOpen
}: HeaderProps) {
  return <header className="sticky top-0 z-10 flex-shrink-0 flex h-16 bg-white shadow" data-id="element-23">
      <button type="button" className="px-4 border-r border-gray-200 text-gray-500 lg:hidden" onClick={() => setSidebarOpen(true)} data-id="element-24">
        <span className="sr-only" data-id="element-25">Open sidebar</span>
        <MenuIcon className="h-6 w-6" data-id="element-26" />
      </button>
      <div className="flex-1 px-4 flex justify-between" data-id="element-27">
        <div className="flex-1 flex items-center" data-id="element-28">
          <h1 className="lg:hidden text-xl font-semibold text-blue-600" data-id="element-29">
            Oxy Pay
          </h1>
        </div>
        <div className="ml-4 flex items-center md:ml-6" data-id="element-30">
          <button className="p-1 rounded-full text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500" data-id="element-31">
            <span className="sr-only" data-id="element-32">View notifications</span>
            <BellIcon className="h-6 w-6" data-id="element-33" />
          </button>
          <div className="ml-3 relative" data-id="element-34">
            <div data-id="element-35">
              <button className="max-w-xs bg-gray-100 rounded-full flex items-center text-sm focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 p-2" data-id="element-36">
                <span className="sr-only" data-id="element-37">Open user menu</span>
                <UserIcon className="h-6 w-6 text-gray-500" data-id="element-38" />
              </button>
            </div>
          </div>
        </div>
      </div>
    </header>;
}